export default {
	getById(id, cb, config) {
		this.http.get(`/page/${id}`, {}, config).then((response) => {
			cb(response)
		})
	},
	update(form, cb, ecb, config) {
		this.http
			.post(`/page`, form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb) {
		this.http
			.get('/page', {
				params
			})
			.then((r) => cb && cb(r))
	},
	remove(id, cb, ecb, config) {
		this.http
			.delete(`/page/${id}`, {}, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
